module.exports = __webpack_public_path__ + "img/c.b881a402.jpg";